/* ZAKDOR - the tracking page, on top of /apps/track.

   The app proxy already answers /apps/track with a plain, reliable page:
   a form, or the parcel's status, steps and courier scans. This script
   keeps all of that as the source of truth and only changes how it is
   shown: a street map in Google's colours with the journey drawn on it, a white
   card floating over it, and once a parcel is found the map eases in on
   the city where it was last scanned.

   Nothing here talks to a new backend. Pressing Track fetches the same
   /apps/track page in the background and reads the result out of it. If
   that fetch fails for any reason the browser simply goes to the plain
   page, so this can never be worse than what was there. */
(function () {
  if (window.__axTrack) return;
  window.__axTrack = 1;
  /* the tracking page itself, and the landing page every Track Order link opens */
  if (!/^\/(apps\/track|pages\/(track-order|track))\/?$/.test(window.location.pathname || '')) return;

  /* where the warehouse is, and enough Indian cities to put the parcel on
     the map. The courier's own words decide what is shown; this list only
     decides where the pin goes. */
  var HUB = [26.80, 84.50];
  var CITIES = [
    ['mumbai',19.08,72.88],['delhi',28.61,77.21],['new delhi',28.61,77.21],['bengaluru',12.97,77.59],
    ['bangalore',12.97,77.59],['hyderabad',17.39,78.49],['chennai',13.08,80.27],['kolkata',22.57,88.36],
    ['pune',18.52,73.86],['ahmedabad',23.02,72.57],['jaipur',26.91,75.79],['lucknow',26.85,80.95],
    ['kanpur',26.45,80.33],['nagpur',21.15,79.09],['indore',22.72,75.86],['bhopal',23.26,77.41],
    ['patna',25.59,85.14],['vadodara',22.31,73.19],['surat',21.17,72.83],['ludhiana',30.90,75.86],
    ['agra',27.18,78.01],['nashik',20.00,73.79],['varanasi',25.32,82.97],['ranchi',23.34,85.31],
    ['guwahati',26.14,91.74],['chandigarh',30.73,76.78],['coimbatore',11.02,76.96],['kochi',9.93,76.27],
    ['thiruvananthapuram',8.52,76.94],['visakhapatnam',17.69,83.22],['bhubaneswar',20.30,85.82],
    ['dehradun',30.32,78.03],['amritsar',31.63,74.87],['jodhpur',26.24,73.02],['udaipur',24.59,73.71],
    ['raipur',21.25,81.63],['gwalior',26.22,78.18],['jabalpur',23.18,79.99],['mysuru',12.30,76.64],
    ['mysore',12.30,76.64],['madurai',9.93,78.12],['vijayawada',16.51,80.65],['guntur',16.31,80.44],
    ['noida',28.54,77.39],['gurugram',28.46,77.03],['gurgaon',28.46,77.03],['ghaziabad',28.67,77.42],
    ['faridabad',28.41,77.31],['meerut',28.98,77.71],['aligarh',27.90,78.08],['bareilly',28.37,79.43],
    ['moradabad',28.84,78.78],['gorakhpur',26.76,83.37],['prayagraj',25.44,81.85],['allahabad',25.44,81.85],
    ['muzaffarpur',26.12,85.39],['gaya',24.79,85.00],['bhagalpur',25.24,86.98],['darbhanga',26.15,85.90],
    ['bettiah',26.80,84.50],['west champaran',26.80,84.50],['motihari',26.65,84.92],['east champaran',26.65,84.92],
    ['siwan',26.22,84.36],['chapra',25.78,84.75],['hajipur',25.69,85.21],['purnia',25.78,87.47],
    ['begusarai',25.42,86.13],['dhanbad',23.80,86.43],['jamshedpur',22.80,86.20],['bokaro',23.67,86.15],
    ['asansol',23.68,86.98],['durgapur',23.52,87.31],['siliguri',26.73,88.40],['howrah',22.59,88.31],
    ['cuttack',20.46,85.88],['rourkela',22.26,84.85],['bilaspur',22.08,82.15],['durg',21.19,81.28],
    ['aurangabad',19.88,75.34],['solapur',17.66,75.91],['kolhapur',16.70,74.24],['thane',19.22,72.98],
    ['navi mumbai',19.03,73.02],['rajkot',22.30,70.80],['bhavnagar',21.76,72.15],['jamnagar',22.47,70.06],
    ['gandhinagar',23.22,72.65],['ajmer',26.45,74.64],['kota',25.21,75.86],['bikaner',28.02,73.31],
    ['jalandhar',31.33,75.58],['patiala',30.34,76.39],['shimla',31.10,77.17],['jammu',32.73,74.87],
    ['srinagar',34.08,74.80],['haridwar',29.95,78.16],['tiruchirappalli',10.79,78.70],['trichy',10.79,78.70],
    ['salem',11.66,78.15],['tirupati',13.63,79.42],['nellore',14.44,79.99],['warangal',17.98,79.59],
    ['kozhikode',11.26,75.78],['calicut',11.26,75.78],['thrissur',10.53,76.21],['mangaluru',12.91,74.86],
    ['mangalore',12.91,74.86],['hubli',15.36,75.12],['belagavi',15.85,74.50],['goa',15.49,73.83],
    ['panaji',15.49,73.83],['agartala',23.83,91.28],['imphal',24.82,93.94],['shillong',25.58,91.89],
    ['aizawl',23.73,92.72],['dibrugarh',27.47,94.91],['itanagar',27.10,93.62]
  ];
  function place(text) {
    var t = String(text || '').toLowerCase(), best = null;
    for (var i = 0; i < CITIES.length; i++) {
      if (t.indexOf(CITIES[i][0]) >= 0 && (!best || CITIES[i][0].length > best[0].length)) best = CITIES[i];
    }
    return best ? { at: [best[1], best[2]], name: best[0] } : null;
  }

  /* ---------------------------------------------------------------- */
  /*  look                                                             */
  /* ---------------------------------------------------------------- */

  var CSS = ''
  /* the whole screen is the map; the page behind it never scrolls */
  + 'html,body{overflow:hidden !important;height:100%}'
  + '.axg{--ink:#1E4494;--deep:#0A1730;--mut:#6B7482;--line:#E6EAF0;--field:#F1F3F6;'
  +   'position:fixed;inset:0;z-index:2147483000;color:var(--deep);font-family:inherit;'
  +   'background:radial-gradient(80% 70% at 50% 40%,#FFFFFF 0%,#F2F5F9 55%,#E6EBF2 100%)}'
  + '.axg *{box-sizing:border-box}'
  + '.axg-stage{position:absolute;inset:0;overflow:hidden}'
  /* .axg before it: MapLibre's own sheet lands later and would otherwise
     make the host position:relative, and a host with no height of its own */
  + '.axg .axg-map{position:absolute;inset:0;background:#F8F4F0;z-index:0;isolation:isolate;'
  +   'opacity:0;visibility:hidden;transition:opacity .55s ease}'
  + '.axg-map.on{opacity:1;visibility:visible}'
  /* the globe: what the page shows until a parcel is actually found */
  + '.axg-globe{position:absolute;inset:0;z-index:1;transition:opacity .45s ease}'
  + '.axg-globe.off{opacity:0;pointer-events:none}'
  + '.axg-globe canvas{position:absolute;inset:0;width:100%;height:100%;display:block;'
  +   'cursor:grab;touch-action:none}'
  + '.axg-globe canvas:active{cursor:grabbing}'
  + '.axg-map .maplibregl-ctrl-attrib{font-size:10px;background:rgba(255,255,255,.7)}'
  + '.axg-map .maplibregl-canvas{outline:none}'
  /* the parcel, in a white card with a tail, the way a courier map shows it */
  + '.axg-pk{position:relative;width:64px;height:64px;border-radius:18px;background:#fff;'
  +   'box-shadow:0 10px 26px rgba(10,23,48,.24);display:grid;place-items:center}'
  + '.axg-pk:after{content:"";position:absolute;left:50%;bottom:-8px;width:16px;height:16px;'
  +   'margin-left:-8px;background:#fff;transform:rotate(45deg);border-radius:3px;'
  +   'box-shadow:6px 6px 12px rgba(10,23,48,.12)}'
  + '.axg-pk svg{position:relative;z-index:1;width:34px;height:34px}'
  + '.axg-dot{width:14px;height:14px;border-radius:50%;background:#16A34A;border:3px solid #fff;'
  +   'box-shadow:0 2px 6px rgba(10,23,48,.3)}'
  + '.axg-back{position:absolute;left:24px;top:22px;z-index:4;width:44px;height:44px;border:0;border-radius:50%;background:#fff;'
  +   'color:var(--deep);cursor:pointer;display:grid;place-items:center;padding:0;box-shadow:0 6px 18px rgba(10,23,48,.1);transition:transform .15s}'
  + '.axg-back:hover{transform:translateX(-2px)}'
  + '.axg-back svg{width:20px;height:20px;fill:none;stroke:currentColor;stroke-width:2.4;stroke-linecap:round;stroke-linejoin:round}'
  + '.axg-card{position:absolute;left:24px;top:84px;z-index:3;width:412px;max-width:calc(100% - 48px);max-height:calc(100% - 108px);'
  +   'background:#fff;border-radius:18px;box-shadow:0 24px 60px rgba(10,23,48,.16);overflow:hidden;display:flex;flex-direction:column;'
  +   'animation:axgIn .45s cubic-bezier(.16,1,.3,1) both}'
  + '@keyframes axgIn{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:none}}'

  /* the form */
  + '.axg-form{padding:22px 24px 24px}'
  + '.axg-h1{margin:0 0 16px;font-size:22px;font-weight:800;letter-spacing:-.02em;color:var(--deep)}'
  + '.axg-tabs{display:flex;border-bottom:1px solid var(--line);margin:0 0 20px}'
  + '.axg-tab{flex:1;background:none;border:0;padding:8px 4px 12px;font:inherit;font-size:15px;font-weight:700;color:#9AA3B2;cursor:pointer;'
  +   'position:relative;transition:color .15s}'
  + '.axg-tab.on{color:var(--deep)}'
  + '.axg-tab.on:after{content:"";position:absolute;left:0;right:0;bottom:-1px;height:2px;background:var(--ink)}'
  + '.axg-in{display:block;width:100%;height:48px;padding:0 16px;border:1px solid transparent !important;border-radius:12px;'
  +   'background:var(--field) !important;color:var(--deep) !important;font:inherit;font-size:15px;margin:0 0 12px;'
  +   '-webkit-appearance:none;appearance:none;transition:border-color .15s,box-shadow .15s,background .15s}'
  + '.axg-in::placeholder{color:#8F98A6 !important;opacity:1}'
  + '.axg-in:focus{outline:0;background:#fff !important;border-color:var(--ink) !important;box-shadow:0 0 0 3px rgba(30,68,148,.14)}'
  + '.axg-go{display:flex;align-items:center;justify-content:center;gap:9px;width:100%;height:50px;margin:8px 0 0;border:0;border-radius:12px;'
  +   'background:var(--ink);color:#fff;font:inherit;font-size:16px;font-weight:700;cursor:pointer;position:relative;transition:background .15s,transform .15s,opacity .2s}'
  + '.axg-go:hover{background:#2C5CC5;transform:translateY(-1px)}'
  + '.axg-go[disabled]{opacity:.75;cursor:progress;transform:none}'
  + '.axg-err{margin:0 0 12px;padding:11px 14px;border-radius:10px;background:#FEF2F3;border:1px solid #F3CBCE;color:#96222A;font-size:13.5px;line-height:1.5}'
  + '.axg-err[hidden]{display:none}'

  /* the result */
  + '.axg-res{display:flex;flex-direction:column;min-height:0;flex:1}'
  + '.axg-head{background:var(--ink);color:#fff;padding:18px 24px 40px;position:relative;flex:0 0 auto}'
  /* the bar you take hold of. Only on a phone, where the card is a sheet
     that can be pulled down to see the map and up to read. */
  + '.axg-grip{display:none}'
  + '.axg-hrow{display:flex;align-items:center;justify-content:space-between;gap:10px}'
  + '.axg-num{font-size:15px;font-weight:700;letter-spacing:.02em;opacity:.85}'
  + '.axg-hacts{display:flex;gap:6px}'
  + '.axg-ib{width:32px;height:32px;border:0;border-radius:8px;background:rgba(255,255,255,.12);color:#fff;cursor:pointer;display:grid;place-items:center;padding:0;transition:background .15s}'
  + '.axg-ib:hover{background:rgba(255,255,255,.22)}'
  + '.axg-ib svg{width:16px;height:16px;fill:none;stroke:currentColor;stroke-width:2.2;stroke-linecap:round;stroke-linejoin:round}'
  + '.axg-ib.spin svg{animation:axgSpin .8s linear infinite}'
  + '@keyframes axgSpin{to{transform:rotate(360deg)}}'
  + '.axg-status{display:flex;align-items:center;justify-content:space-between;gap:14px;margin:22px 0 0}'
  + '.axg-status b{font-size:30px;font-weight:800;letter-spacing:-.02em;line-height:1.1}'
  + '.axg-status svg{width:56px;height:56px;flex:0 0 auto;fill:none;stroke:#fff;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;opacity:.95}'
  + '.axg-when{margin:8px 0 0;font-size:13px;opacity:.85;line-height:1.5}'
  + '.axg-prog{display:flex;gap:5px;margin:16px 0 0}'
  + '.axg-prog i{flex:1;height:4px;border-radius:4px;background:rgba(255,255,255,.22)}'
  + '.axg-prog i.on{background:#fff}'
  /* the card scrolls on its own; reaching its end must not start dragging
     the map underneath it, which is what made the scroll feel like it
     caught on something */
  + '.axg-body{overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;'
  +   'flex:1;min-height:0;padding:0 0 8px}'
  + '.axg-body>.axg-note:first-child,.axg-body>.axg-meta:first-child{margin-top:14px}'
  + '.axg-pack{flex:0 0 auto;margin:-22px 16px 0;background:#fff;border-radius:14px;box-shadow:0 10px 30px rgba(10,23,48,.12);padding:16px 18px;position:relative;z-index:1}'
  + '.axg-pack b{display:block;font-size:15px;font-weight:700}'
  + '.axg-pack small{display:block;font-size:13px;color:var(--mut);margin-top:2px}'
  + '.axg-pack p{margin:10px 0 0;font-size:13px;color:var(--deep);line-height:1.5;padding-top:10px;border-top:1px solid var(--line)}'
  + '.axg-note{margin:14px 16px 0;padding:11px 14px;border-radius:12px;font-size:13px;line-height:1.5;border:1px solid transparent}'
  + '.axg-note.good{background:#EAF7EF;border-color:#C4EBD4;color:#0F5B30}'
  + '.axg-note.warn{background:#FFF6E6;border-color:#F3DFB3;color:#7A5200}'
  + '.axg-note.bad{background:#FEF2F3;border-color:#F3CBCE;color:#96222A}'
  + '.axg-meta{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin:14px 16px 0}'
  + '.axg-meta div{background:var(--field);border-radius:12px;padding:10px 12px;min-width:0}'
  + '.axg-meta .k{display:block;font-size:10.5px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:var(--mut);margin-bottom:3px}'
  + '.axg-meta .v{display:flex;align-items:center;gap:8px;flex-wrap:wrap;font-size:13.5px;font-weight:600;overflow-wrap:anywhere}'
  + '.axg-tick{width:18px;height:18px;border-radius:50%;background:#16A34A;display:inline-grid;place-items:center;flex:0 0 auto}'
  + '.axg-tick svg{width:11px;height:11px;fill:none;stroke:#fff;stroke-width:3;stroke-linecap:round;stroke-linejoin:round}'
  + '.axg-copy{background:#fff;border:1px solid var(--line);color:var(--ink);border-radius:6px;padding:2px 7px;font-size:10.5px;font-weight:700;letter-spacing:.05em;cursor:pointer}'
  + '.axg-copy:hover{border-color:var(--ink)}'
  + '.axg-tl{list-style:none;margin:18px 0 0;padding:0 20px 8px 20px}'
  + '.axg-tl li{display:grid;grid-template-columns:52px 1fr;gap:14px;position:relative;padding:0 0 18px}'
  + '.axg-tl li:before{content:"";position:absolute;left:25px;top:50px;bottom:0;border-left:2px dashed var(--line)}'
  + '.axg-tl li:last-child:before{display:none}'
  + '.axg-date{align-self:start;width:52px;height:48px;border-radius:10px;background:var(--field);color:var(--mut);display:flex;flex-direction:column;'
  +   'align-items:center;justify-content:center;font-size:12.5px;font-weight:700;line-height:1.15;text-align:center}'
  + '.axg-date.on{background:var(--ink);color:#fff}'
  + '.axg-ev{min-width:0}'
  + '.axg-ev time{display:block;font-size:13px;color:var(--mut);margin:0 0 3px}'
  + '.axg-ev p{margin:0 0 12px;font-size:14px;line-height:1.45;color:var(--deep)}'
  + '.axg-ev p.on{font-weight:700}'
  + '.axg-ev p small{display:block;font-size:12.5px;color:var(--mut);font-weight:400;margin-top:2px}'
  + '.axg-ev p:last-child{margin-bottom:0}'
  + '.axg-empty{margin:18px 16px 8px;padding:14px;border:1px dashed var(--line);border-radius:12px;font-size:13px;color:var(--mut);line-height:1.55}'
  + '.axg-wa{position:absolute;right:24px;top:22px;z-index:4;display:inline-flex;align-items:center;gap:9px;'
  +   'height:44px;padding:0 18px;border-radius:999px;background:#fff;color:var(--deep);font:inherit;font-size:14px;'
  +   'font-weight:700;text-decoration:none;box-shadow:0 6px 18px rgba(10,23,48,.12);transition:transform .15s}'
  + '.axg-wa:hover{transform:translateY(-1px)}'
  + '.axg-wa svg{width:18px;height:18px;fill:none;stroke:#1FA855;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}'

  + '.axg .axl-b{--axl-ink:#fff}'
  + '@media(max-width:860px){'
  +   '.axg-back{left:14px;top:14px}'
  +   '.axg-wa{right:14px;top:14px;height:40px;padding:0 15px;font-size:13px}'
  /* Three places it settles: pulled down to a peek, where it opens, and
     up out of the way. height, not max-height, so it can be animated and
     dragged; the body inside keeps its own scroll either way. */
  +   '.axg-card{left:12px;right:12px;top:auto;bottom:12px;width:auto;max-width:none;max-height:calc(100% - 84px)}'
  /* only the result card is a sheet. The form is a form: it stands at its
     own height, the way it always has. */
  +   '.axg-card.axg-sheet{height:60%;transition:height .34s cubic-bezier(.32,.72,0,1)}'
  +   '.axg-card.axg-sheet.axg-min{height:148px}'
  +   '.axg-card.axg-sheet.axg-max{height:calc(100% - 84px)}'
  /* while a finger is on it there is no easing - it follows the finger */
  +   '.axg-card.axg-drag{transition:none}'
  +   '.axg-grip{display:block;position:absolute;left:50%;top:7px;width:40px;height:4px;margin-left:-20px;'
  +     'border-radius:3px;background:rgba(255,255,255,.34);z-index:2}'
  /* the head is the handle: room at the top for the bar, and the browser
     must not pan or scroll from it while a finger is dragging */
  +   '.axg-head,.axg-grip{touch-action:none}'
  +   '.axg-head{padding:22px 20px 36px}'
  +   '.axg-status b{font-size:25px}'
  + '}'
  + '@media(prefers-reduced-motion:reduce){.axg-card{animation:none}.axg-ib.spin svg{animation:none}}';

  /* ---------------------------------------------------------------- */
  /*  reading the plain page                                           */
  /* ---------------------------------------------------------------- */

  function txt(el) { return el ? String(el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }

  /* Turns the app's own markup into plain data. Two shapes come back:
     { kind: 'form', error } or { kind: 'result', ... }. */
  function read(root) {
    if (!root) return { kind: 'none' };
    var wrap = root.querySelector('.zt-wrap') || root;
    if (wrap.querySelector('.zt-form')) {
      return { kind: 'form', error: txt(wrap.querySelector('.zt-note.zt-bad')) };
    }
    if (!wrap.querySelector('.zt-status')) return { kind: 'none' };

    var steps = [];
    var stepEls = wrap.querySelectorAll('.zt-step');
    for (var i = 0; i < stepEls.length; i++) {
      steps.push({ label: txt(stepEls[i].querySelector('.zt-slab')), on: stepEls[i].classList.contains('on'), now: stepEls[i].classList.contains('now') });
    }
    var noteEl = wrap.querySelector('.zt-note');
    var note = noteEl ? { text: txt(noteEl), tone: noteEl.classList.contains('zt-good') ? 'good' : noteEl.classList.contains('zt-bad') ? 'bad' : 'warn' } : null;
    var meta = [];
    var metaEls = wrap.querySelectorAll('.zt-meta > div');
    for (var m = 0; m < metaEls.length; m++) meta.push({ k: txt(metaEls[m].querySelector('.k')), v: txt(metaEls[m].querySelector('.v')) });
    var scans = [];
    var li = wrap.querySelectorAll('.zt-hist li');
    for (var s = 0; s < li.length; s++) scans.push({ t: txt(li[s].querySelector('.t')), d: txt(li[s].querySelector('.d')), l: txt(li[s].querySelector('.l')) });
    function metaOf(key) {
      for (var j = 0; j < meta.length; j++) if (meta[j].k.toLowerCase().indexOf(key) === 0) return meta[j].v;
      return '';
    }
    var lastLoc = '';
    for (var q = 0; q < scans.length; q++) { if (scans[q].l) { lastLoc = scans[q].l; break; } }
    return {
      kind: 'result',
      status: txt(wrap.querySelector('.zt-status')), when: txt(wrap.querySelector('.zt-when')),
      order: txt(wrap.querySelector('.zt-ord b')), items: txt(wrap.querySelector('.zt-ord span')),
      steps: steps, note: note, meta: meta, scans: scans,
      city: metaOf('deliver'), lastLoc: lastLoc
    };
  }

  /* ---------------------------------------------------------------- */
  /*  markup                                                           */
  /* ---------------------------------------------------------------- */

  function esc(t) {
    return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  var I = {
    back: '<svg viewBox="0 0 24 24"><path d="M15 5l-7 7 7 7"/></svg>',
    refresh: '<svg viewBox="0 0 24 24"><path d="M20 12a8 8 0 1 1-2.3-5.7"/><path d="M20 4v5h-5"/></svg>',
    close: '<svg viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"/></svg>',
    check: '<svg viewBox="0 0 24 24"><path d="M4 12.5l5 5L20 6.5"/></svg>',
    truck: '<svg viewBox="0 0 24 24"><rect x="1.5" y="6" width="13" height="10" rx="1.5"/><path d="M14.5 9h4l3 3.5V16h-7z"/><circle cx="6" cy="18" r="1.6"/><circle cx="18" cy="18" r="1.6"/></svg>',
    wa: '<svg viewBox="0 0 24 24"><path d="M21 11.5a8.5 8.5 0 0 1-12.7 7.4L3 20.5l1.7-5.2A8.5 8.5 0 1 1 21 11.5z"/></svg>',
    /* a real cardboard parcel: kraft brown, tape down the seam */
    box: '<svg viewBox="0 0 32 32" stroke="#8A5A2B" stroke-width="1" stroke-linejoin="round">'
      + '<path d="M16 3.6 29 10.1 16 16.6 3 10.1z" fill="#E0AE72"/>'
      + '<path d="M3 10.1 16 16.6v11.8L3 21.9z" fill="#C08A4E"/>'
      + '<path d="M29 10.1 16 16.6v11.8l13-6.5z" fill="#A5713B"/>'
      + '<path d="M9.5 6.85 22.5 13.35 20 14.6 7 8.1z" fill="#F2DCB8" stroke="none"/>'
      + '<path d="M13.4 15.3 16 16.6l2.6-1.3v11.8L16 28.4l-2.6-1.3z" fill="#EBD3AC" stroke="none" opacity=".9"/>'
      + '</svg>'
  };

  /* Deliberately not a <form>: the theme's loading veil listens for every
     submit on the page, and this lookup happens in place. Enter still works. */
  function formHtml(q, error, byNum) {
    return '<div class="axg-form">'
      + '<h1 class="axg-h1">Track Order</h1>'
      + '<div class="axg-tabs">'
      + '<button type="button" class="axg-tab' + (byNum ? '' : ' on') + '" data-tab="order">Order Number</button>'
      + '<button type="button" class="axg-tab' + (byNum ? ' on' : '') + '" data-tab="n">Tracking Number</button></div>'
      + '<div class="axg-err" id="axgErr" role="alert"' + (error ? '' : ' hidden') + '>' + esc(error) + '</div>'
      + (byNum
        ? '<input class="axg-in" id="axgN" value="' + esc(q.n) + '" placeholder="Tracking Number" autocomplete="off" enterkeyhint="search" aria-label="Tracking number">'
        : '<input class="axg-in" id="axgO" value="' + esc(q.order) + '" placeholder="Order Number" autocomplete="off" enterkeyhint="next" aria-label="Order number">'
          + '<input class="axg-in" id="axgP" value="' + esc(q.pin) + '" placeholder="Phone Number - last 4 digits" inputmode="numeric" maxlength="4" autocomplete="off" enterkeyhint="search" aria-label="Last 4 digits of phone number">')
      + '<button class="axg-go" type="button" id="axgGo"><span>Track</span></button>'
      + '</div>';
  }

  function splitWhen(t) {
    var i = t.indexOf(',');
    if (i < 0) return { date: t, time: '' };
    return { date: t.slice(0, i).trim(), time: t.slice(i + 1).trim() };
  }

  function resultHtml(r) {
    var delivered = /deliver/i.test(r.status) && !/out for/i.test(r.status);
    var doneSteps = 0;
    for (var s = 0; s < r.steps.length; s++) if (r.steps[s].on) doneSteps++;
    var prog = '';
    for (var p = 0; p < r.steps.length; p++) prog += '<i' + (p < doneSteps ? ' class="on"' : '') + '></i>';

    var meta = '';
    for (var m = 0; m < r.meta.length; m++) {
      var k = r.meta[m].k.toLowerCase(), v = esc(r.meta[m].v);
      if (k.indexOf('payment') === 0) {
        var amt = r.meta[m].v.match(/₹\s*[\d,.]+/);
        v = /cash|cod/i.test(r.meta[m].v)
          ? 'Cash on Delivery' + (amt ? ' &middot; ' + esc(amt[0]) : '')
          : '<i class="axg-tick">' + I.check + '</i>Paid';
      }
      meta += '<div><span class="k">' + esc(r.meta[m].k) + '</span><span class="v">' + v
        + (k.indexOf('tracking') === 0 ? '<span class="axg-copy" role="button" tabindex="0" data-copy="' + esc(r.meta[m].v) + '">COPY</span>' : '') + '</span></div>';
    }

    var tl = '';
    if (r.scans.length) {
      var lastDate = null, open = false;
      for (var j = 0; j < r.scans.length; j++) {
        var w = splitWhen(r.scans[j].t);
        if (w.date !== lastDate) {
          if (open) tl += '</div></li>';
          var dp = w.date.split(' ');
          tl += '<li><span class="axg-date' + (j === 0 ? ' on' : '') + '">' + esc(dp[0]) + '<br>' + esc(dp.slice(1).join(' ')) + '</span><div class="axg-ev">';
          lastDate = w.date; open = true;
        }
        tl += '<time>' + esc(w.time || w.date) + '</time><p' + (j === 0 ? ' class="on"' : '') + '>' + esc(r.scans[j].d)
          + (r.scans[j].l ? '<small>' + esc(r.scans[j].l) + '</small>' : '') + '</p>';
      }
      if (open) tl += '</div></li>';
      tl = '<ol class="axg-tl">' + tl + '</ol>';
    } else {
      tl = '<div class="axg-empty">No courier scans yet. The first scan usually appears within 24 hours of dispatch, and we will message you on WhatsApp the moment it does.</div>';
    }

    var count = 0, mm = r.items.match(/×\s*(\d+)/g) || [];
    for (var c = 0; c < mm.length; c++) count += Number(mm[c].replace(/\D/g, '')) || 0;
    return '<div class="axg-res">'
      + '<div class="axg-head">'
      + '<div class="axg-grip"></div>'
      + '<div class="axg-hrow"><span class="axg-num">' + esc(r.order.replace(/^#/, '')) + '</span>'
      + '<span class="axg-hacts"><button type="button" class="axg-ib" id="axgRefresh" aria-label="Refresh">' + I.refresh + '</button>'
      + '<button type="button" class="axg-ib" id="axgAgain" aria-label="Close">' + I.close + '</button></span></div>'
      + '<div class="axg-status"><b>' + esc(r.status) + '</b>' + (delivered ? I.check : I.truck) + '</div>'
      + (r.when ? '<p class="axg-when">' + esc(r.when) + '</p>' : '')
      + (prog ? '<div class="axg-prog">' + prog + '</div>' : '')
      + '</div>'
      + '<div class="axg-pack"><b>Package Contents</b><small>' + (count ? count + ' item' + (count === 1 ? '' : 's') : 'Your order') + '</small>'
      + (r.items ? '<p>' + esc(r.items) + '</p>' : '') + '</div>'
      + '<div class="axg-body">'
      + (r.note ? '<div class="axg-note ' + r.note.tone + '">' + esc(r.note.text) + '</div>' : '')
      + (meta ? '<div class="axg-meta">' + meta + '</div>' : '')
      + tl
      + '</div>'
      + '</div>';
  }

  /* ---------------------------------------------------------------- */
  /*  the map                                                          */
  /* ---------------------------------------------------------------- */

  /* The map is drawn from vectors, not from pictures of a map. Every name
     is set in type at the size of the screen it is on, so it stays sharp
     on a phone where a tile's baked-in lettering came out torn - and the
     zoom stops wherever the finger stops, the way Google's does, because
     nothing has to land on a whole level to be readable. The tiles come
     from OpenFreeMap, which asks for no key and stamps nothing across
     them; MapLibre draws them. It is sent for the moment the page mounts,
     so it has usually arrived and built the map, out of sight behind the
     globe, by the time an order number has been typed. If it never comes
     the page still works - it simply has no map behind the card. */
  var MAPLIB = 'https://cdnjs.cloudflare.com/ajax/libs/maplibre-gl/4.7.1/maplibre-gl';
  var STYLE = 'https://tiles.openfreemap.org/styles/liberty';
  var libWaiting = [];
  function lib(cb) {
    if (window.maplibregl) { if (cb) cb(); return; }
    if (cb) libWaiting.push(cb);
    if (document.getElementById('axgLib')) return;
    var css = document.createElement('link'); css.rel = 'stylesheet'; css.href = MAPLIB + '.css';
    document.head.appendChild(css);
    var js = document.createElement('script'); js.id = 'axgLib'; js.src = MAPLIB + '.js'; js.async = true;
    js.onload = function () { var q = libWaiting; libWaiting = []; for (var i = 0; i < q.length; i++) q[i](); };
    document.head.appendChild(js);
  }

  function mapUp(host, wide) {
    if (!window.maplibregl || !host) return null;
    var m;
    try {
      m = new maplibregl.Map({
        container: host, style: STYLE, center: [80.5, 22.6], zoom: wide ? 4 : 3,
        minZoom: 2, maxZoom: 19, attributionControl: { compact: true },
        dragRotate: false, pitchWithRotate: false, touchPitch: false
      });
      m.touchZoomRotate.disableRotation();
      m.keyboard.disableRotation();
    } catch (e) { return null; }

    /* the card covers part of the map - on a computer down the left, on a
       phone across the bottom - so the journey is fitted into what is left.
       The phone card can be most of the screen; the padding always leaves
       a strip at the top to fit into, or there would be nowhere to go. */
    function pads() {
      var card = document.getElementById('axgPanel');
      var h = card ? card.getBoundingClientRect().height : 0;
      return wide
        ? { left: 470, top: 90, right: 50, bottom: 50 }
        : { left: 40, top: 80, right: 40, bottom: Math.max(0, Math.min(Math.round(h) + 30, host.clientHeight - 220)) };
    }

    /* Place names the way Google sets them: English first, on one line, and
       the villages and localities in from town level. The style's own place
       labels set every name in two scripts and hold the small places back,
       so around a town most of them never found room. Same tiles, same
       font - nothing more is fetched for this.

       And the way Google fills in as you come closer: every kind of place is
       offered from the town level on, the bigger ones set down first where
       two would collide (the tiles rank each place), the names packed
       closer than the style allows, and they grow with the zoom so a name
       is still readable with the map right up close. What does not fit at
       one level appears at the next; nothing is held back on purpose. */
    function names() {
      if (!m.getSource('openmaptiles')) return;
      var NAME = ['coalesce', ['get', 'name:en'], ['get', 'name:latin'], ['get', 'name']];
      var FIRST = ['coalesce', ['get', 'rank'], 30];
      var ids = ['label_city_capital', 'label_city', 'label_town', 'label_village', 'label_other'];
      for (var i = 0; i < ids.length; i++) {
        if (!m.getLayer(ids[i])) continue;
        if (i < 2) m.setLayoutProperty(ids[i], 'text-field', NAME);
        else m.setLayoutProperty(ids[i], 'visibility', 'none');
      }
      m.addLayer({
        id: 'axg-town', type: 'symbol', source: 'openmaptiles', 'source-layer': 'place', minzoom: 6,
        filter: ['==', ['get', 'class'], 'town'],
        layout: { 'text-field': NAME, 'text-font': ['Noto Sans Regular'], 'text-max-width': 8,
          'text-padding': 1, 'symbol-sort-key': FIRST,
          'text-size': ['interpolate', ['linear'], ['zoom'], 6, 11, 11, 14, 16, 17] },
        paint: { 'text-color': '#1F2937', 'text-halo-color': '#fff', 'text-halo-width': 1.2 }
      });
      m.addLayer({
        id: 'axg-place', type: 'symbol', source: 'openmaptiles', 'source-layer': 'place', minzoom: 8,
        filter: ['match', ['get', 'class'], ['village', 'hamlet', 'suburb', 'quarter', 'neighbourhood', 'isolated_dwelling'], true, false],
        layout: { 'text-field': NAME, 'text-font': ['Noto Sans Regular'], 'text-max-width': 8,
          'text-padding': 1, 'symbol-sort-key': FIRST,
          'text-size': ['interpolate', ['linear'], ['zoom'], 8, 10, 12, 12, 14, 13, 17, 16] },
        paint: { 'text-color': '#3B4252', 'text-halo-color': '#fff', 'text-halo-width': 1 }
      });
    }

    /* the journey is one line on one source; the pins are plain elements */
    var ready = false, todo = null, marks = [];
    var EMPTY = { type: 'FeatureCollection', features: [] };
    m.on('load', function () {
      m.addSource('axg', { type: 'geojson', data: EMPTY });
      m.addLayer({
        id: 'axg-line', type: 'line', source: 'axg',
        layout: { 'line-cap': 'round', 'line-join': 'round' },
        paint: { 'line-color': '#16A34A', 'line-width': 5, 'line-opacity': .95 }
      });
      names();
      ready = true;
      if (todo) { var f = todo; todo = null; f(); }
    });
    function whenReady(f) { if (ready) f(); else todo = f; }
    function clear() {
      for (var i = 0; i < marks.length; i++) marks[i].remove();
      marks = [];
      if (ready) m.getSource('axg').setData(EMPTY);
    }
    function mark(at, html, anchor, offset) {
      var box = document.createElement('div'); box.innerHTML = html;
      marks.push(new maplibregl.Marker({ element: box.firstChild, anchor: anchor, offset: offset })
        .setLngLat([at[1], at[0]]).addTo(m));
    }
    function lngLat(p) { return [p[1], p[0]]; }

    return {
      resize: function () { m.resize(); },
      rest: function () { clear(); m.easeTo({ center: [80.5, 22.6], zoom: wide ? 4 : 3, duration: 1200 }); },
      waiting: function () { clear(); m.easeTo({ center: [80.5, 22.6], zoom: wide ? 5 : 4, duration: 1200 }); },
      route: function (r) {
        whenReady(function () {
          clear();
          /* every place the courier has scanned it, oldest first, with the
             warehouse at the head of the line */
          var stops = [HUB], seen = {};
          for (var i = r.scans.length - 1; i >= 0; i--) {
            var p = place(r.scans[i].l);
            if (p && !seen[p.name]) { seen[p.name] = 1; stops.push(p.at); }
          }
          var to = place(r.city || r.lastLoc);
          if (to && !seen[to.name]) stops.push(to.at);
          if (stops.length < 2 && to) stops.push(to.at);

          for (var k = 0; k < stops.length; k++) mark(stops[k], '<div class="axg-dot"></div>', 'center', [0, 0]);
          if (stops.length > 1) {
            var line = []; for (var q = 0; q < stops.length; q++) line.push(lngLat(stops[q]));
            m.getSource('axg').setData({ type: 'Feature', properties: {}, geometry: { type: 'LineString', coordinates: line } });
          }
          var last = stops[stops.length - 1];
          /* the parcel card floats nine pixels clear of its spot, with the
             tail pointing down at it */
          mark(last, '<div class="axg-pk">' + I.box + '</div>', 'bottom', [0, -9]);
          /* A parcel that has only moved inside one city gives a box a few
             streets wide, and the fit would dive to street level: roads, no
             town, no sense of where the thing actually is. Town level is the
             floor. */
          if (stops.length > 1) {
            var b = new maplibregl.LngLatBounds(lngLat(stops[0]), lngLat(stops[0]));
            for (var z = 1; z < stops.length; z++) b.extend(lngLat(stops[z]));
            m.fitBounds(b, { padding: pads(), maxZoom: wide ? 9 : 8, duration: 1200 });
          } else m.easeTo({ center: lngLat(last), zoom: wide ? 9 : 8, duration: 1200 });
        });
      }
    };
  }

  /* ---------------------------------------------------------------- */
  /*  wiring                                                           */
  /* ---------------------------------------------------------------- */

  var params = {};
  try {
    var sp = new URLSearchParams(window.location.search);
    params = { order: sp.get('order') || '', pin: sp.get('pin') || '', n: sp.get('n') || '' };
  } catch (e) { params = { order: '', pin: '', n: '' }; }

  function mount() {
    var plain = document.querySelector('.zt-wrap');
    var landing = document.querySelector('.axt');
    var main = document.getElementById('MainContent') || document.body;
    if (document.getElementById('axg')) return;

    var s = document.createElement('style'); s.textContent = CSS; document.head.appendChild(s);

    var root = document.createElement('section');
    root.id = 'axg'; root.className = 'axg';
    root.innerHTML = '<div class="axg-stage">'
      + '<div class="axg-map" id="axgMap"></div>'
      + '<div class="axg-globe" id="axgGlobe"></div>'
      + '<button type="button" class="axg-back" id="axgBack" aria-label="Back">' + I.back + '</button>'
      + '<a class="axg-wa" href="https://wa.me/917982528695" target="_blank" rel="noopener">' + I.wa + 'Help</a>'
      + '<div class="axg-card" id="axgPanel"></div></div>';

    var old = plain || landing;
    if (old && old.parentNode) { old.parentNode.insertBefore(root, old); old.style.display = 'none'; }
    else main.insertBefore(root, main.firstChild);

    var wide = root.getBoundingClientRect().width > 860;
    var mapHost = document.getElementById('axgMap');
    var globeHost = document.getElementById('axgGlobe');
    /* the map is built the moment its library lands - usually while the
       order number is still being typed. If the answer got here first, it
       is drawn now. */
    var map = null, lastR = null;
    lib(function () {
      if (map) return;
      map = mapUp(mapHost, wide);
      if (map && lastR) { map.resize(); map.route(lastR); }
    });

    /* The globe is what the page rests on: it turns while the shopper types
       and while we ask the courier. The street map only comes up once there
       is a real journey to draw on it, and then the globe steps aside. */
    var KIT = window.__axGlobe;
    /* The dive goes far deeper than it used to. At 3.4 the planet barely
       moved before the map took its place, which read as a zoom that had
       stalled; this far in it fills the frame and past it, so the street map
       that follows is the ground you just fell to. */
    var globe = (KIT && KIT.Globe && globeHost)
      ? new KIT.Globe(globeHost, { zoom: wide ? 5.4 : 4.8, zoomCx: wide ? 0.66 : 0.5, zoomCy: wide ? 0.5 : 0.34 })
      : null;
    if (!globe && globeHost) globeHost.classList.add('off');

    function showGlobe() {
      if (globeHost && globe) { globeHost.classList.remove('off'); globe.start(); }
      if (mapHost) mapHost.classList.remove('on');
    }
    function showMap() {
      if (!mapHost) return;
      mapHost.classList.add('on');
      if (map) map.resize();
      if (globeHost) globeHost.classList.add('off');
      /* Behind the map the globe was still turning - five thousand dots
         redrawn sixty times a second at nobody. It stops once it has faded. */
      if (globe) setTimeout(function () { globe.stop(); }, 600);
    }
    document.getElementById('axgBack').addEventListener('click', function () {
      if (document.referrer && document.referrer.indexOf(window.location.host) > 0) history.back();
      else window.location.href = '/';
    });
    var panel = document.getElementById('axgPanel');
    var busy = false, lastQ = null, lastUrl = '';

    function showForm(q, error, byNum) {
      lastR = null;
      panel.innerHTML = formHtml(q, error, byNum);
      panel.classList.remove('axg-sheet');
      panel.dispatchEvent(new Event('axgcard'));
      showGlobe();
      if (globe) globe.rest();
      if (map) map.rest();
    }

    function showResult(r) {
      lastR = r;
      panel.innerHTML = resultHtml(r);
      panel.classList.add('axg-sheet');
      panel.dispatchEvent(new Event('axgcard'));
      showMap();
      if (map) map.route(r);
    }

    function fail(msg) {
      var err = document.getElementById('axgErr');
      if (err) { err.textContent = msg; err.hidden = false; }
    }

    function submit() {
      if (busy) return;
      var byNum = !!document.getElementById('axgN');
      var q = { order: '', pin: '', n: '' };
      if (byNum) q.n = (document.getElementById('axgN').value || '').trim();
      else {
        q.order = (document.getElementById('axgO').value || '').trim();
        q.pin = (document.getElementById('axgP').value || '').replace(/\D/g, '');
      }
      if (byNum ? !q.n : (!q.order || q.pin.length !== 4)) {
        fail(byNum ? 'Enter the tracking number from your courier message.' : 'Enter your order number and the last 4 digits of your phone number.');
        var bad = byNum ? document.getElementById('axgN') : (!q.order ? document.getElementById('axgO') : document.getElementById('axgP'));
        if (bad) bad.focus();
        return;
      }
      var url = '/apps/track?' + (q.n ? 'n=' + encodeURIComponent(q.n) : 'order=' + encodeURIComponent(q.order) + '&pin=' + encodeURIComponent(q.pin));
      if (!window.fetch || !window.DOMParser || !window.history || !history.replaceState) { window.location.href = url; return; }
      track(q, url, false);
    }

    /* 1100ms. The dive now settles in about a second, so this is the moment
       it has landed rather than a wait sitting on top of it. A slower answer
       simply arrives later - the dive has long since finished by then. */
    function track(q, url, refresh) {
      busy = true;
      var go = document.getElementById('axgGo');
      if (go) { go.disabled = true; go.querySelector('span').textContent = 'Finding your parcel…'; }
      var rb = document.getElementById('axgRefresh');
      if (rb) rb.classList.add('spin');
      var err = document.getElementById('axgErr'); if (err) err.hidden = true;
      if (!refresh) { if (globe) globe.zoomIn(); if (map) map.waiting(); }
      var began = Date.now();
      fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (r) { if (!r.ok) throw new Error('bad'); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var data = read(doc);
          if (data.kind === 'none') throw new Error('shape');
          setTimeout(function () {
            busy = false;
            if (!refresh) history.replaceState({ axg: 1 }, '', url);
            if (data.kind === 'form') showForm(q, data.error || 'Nothing matched that. Please check the number and try again.', !!q.n);
            else { lastQ = q; lastUrl = url; showResult(data); }
          }, Math.max(0, (refresh ? 500 : 1100) - (Date.now() - began)));
        })
        .catch(function () {
          busy = false;
          if (refresh) { var b = document.getElementById('axgRefresh'); if (b) b.classList.remove('spin'); return; }
          window.location.href = url;
        });
    }

    panel.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('#axgGo')) { submit(); return; }
      var tab = t.closest('.axg-tab');
      if (tab) {
        var toNum = tab.getAttribute('data-tab') === 'n';
        if (toNum === !!document.getElementById('axgN')) return;
        showForm({ order: '', pin: '', n: '' }, '', toNum);
        var first = panel.querySelector('input'); if (first) first.focus();
        return;
      }
      if (t.closest('#axgRefresh')) { if (lastUrl && !busy) track(lastQ, lastUrl, true); return; }
      if (t.closest('#axgAgain')) {
        history.replaceState({ axg: 1 }, '', '/apps/track');
        showForm({ order: '', pin: '', n: '' }, '', false);
        var f2 = panel.querySelector('input'); if (f2) f2.focus();
        return;
      }
      var c = t.closest('[data-copy]');
      if (c && navigator.clipboard) {
        navigator.clipboard.writeText(c.getAttribute('data-copy')).then(function () {
          c.textContent = 'COPIED'; setTimeout(function () { c.textContent = 'COPY'; }, 1600);
        }).catch(function () {});
      }
    });
    panel.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var t = e.target;
      if (t && t.tagName === 'INPUT') {
        e.preventDefault();
        if (t.id === 'axgO') { var p = document.getElementById('axgP'); if (p && !p.value) { p.focus(); return; } }
        submit();
      } else if (t && t.hasAttribute && t.hasAttribute('data-copy')) { e.preventDefault(); t.click(); }
    });

    /* On a phone the card is a sheet you can pull.

       Down to a peek and the map is the whole screen; up and it sits where
       it opens now; further up and it is out of the way for reading. A drag
       is settled by where the finger lets go, whichever of the three is
       nearest. And the details pull it up by themselves: the moment someone
       scrolls the timeline they want the room, so it goes to the top.

       Nothing here runs on a computer, where the card stands beside the map
       and never covers it. */
    if (!wide) {
      var at = 1, y0 = 0, h0 = 0, held = false, moved = false, onGrip = false;

      function stops() {
        var full = root.clientHeight;
        return [148, Math.round(full * 0.6), Math.max(260, full - 84)];
      }
      function settle(i) {
        at = i < 0 ? 0 : i > 2 ? 2 : i;
        panel.style.height = '';
        panel.classList.remove('axg-drag');
        panel.classList.toggle('axg-min', at === 0);
        panel.classList.toggle('axg-max', at === 2);
      }
      function nearest(h) {
        var s = stops(), best = 0, gap = Infinity;
        for (var i = 0; i < 3; i++) { var d = Math.abs(s[i] - h); if (d < gap) { gap = d; best = i; } }
        return best;
      }
      function letGo() {
        if (!held) return;
        held = false;
        /* A press on the bar that went nowhere is a tap: step it up, and
           round again from the top. Decided here rather than on a click,
           because the drag captures the pointer and a click that follows a
           capture is not delivered where it was aimed. */
        if (!moved) return settle(onGrip ? (at === 2 ? 0 : at + 1) : at);
        settle(nearest(panel.getBoundingClientRect().height));
      }

      panel.addEventListener('pointerdown', function (e) {
        if (!e.target.closest) return;
        /* the head is the handle - but its buttons are still buttons */
        if (!e.target.closest('.axg-head') || e.target.closest('button')) return;
        held = true; moved = false;
        onGrip = !!e.target.closest('.axg-grip');
        y0 = e.clientY;
        h0 = panel.getBoundingClientRect().height;
        panel.classList.add('axg-drag');
        try { panel.setPointerCapture(e.pointerId); } catch (err) {}
      });
      panel.addEventListener('pointermove', function (e) {
        if (!held) return;
        var dy = e.clientY - y0;
        if (!moved && Math.abs(dy) < 3) return;
        moved = true;
        var s = stops();
        panel.style.height = Math.max(96, Math.min(s[2], h0 - dy)) + 'px';
      });
      panel.addEventListener('pointerup', letGo);
      panel.addEventListener('pointercancel', letGo);

      /* scroll doesn't bubble, so it is caught on the way down */
      panel.addEventListener('scroll', function (e) {
        var b = e.target;
        if (at === 2 || !b || !b.classList || !b.classList.contains('axg-body')) return;
        if (b.scrollTop > 4) settle(2);
      }, true);

      /* every new card opens where it opens */
      panel.addEventListener('axgcard', function () { settle(1); });
    }

    var first = read(plain);
    if (first.kind === 'result') { lastQ = params; lastUrl = window.location.pathname + window.location.search; showResult(first); }
    else showForm(params, first.kind === 'form' ? first.error : '', !!params.n);

    window.addEventListener('popstate', function () { window.location.reload(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
})();